// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__WP0jg","list":"PatternAutocomplete_list__3kfBU"};